import { Application } from '@hotwired/stimulus'

import MenuController from './menu_controller'
import SlugController from './slug_controller'
import UploadPreviewController from './upload_preview_controller'
import ModalController from './modal_controller'
import SponsorFormController from './sponsor_form_controller'
import CopyTokenController from './copy_token_controller'

const application = Application.start()

application.register('menu', MenuController)
application.register('slug', SlugController)
application.register('upload-preview', UploadPreviewController)
application.register('modal', ModalController)
application.register('sponsor-form', SponsorFormController)
application.register('copy-token', CopyTokenController)

window.Stimulus = application
